import { styled } from "@mui/system"
import Box from "@mui/material/Box"
import LinearProgress from "@mui/material/LinearProgress"
import {
    MELOGY_TRANSPARENT,
    MELOGY_WHITE,
    MELOGY_BACKGROUND_MEDIUM_LIGHT_GREY,
    MELOGY_BACKGROUND_2XLIGHT_GREY,
} from "../../style/colors"

const CustomLinearProgress = styled(LinearProgress)(({ progress }) => ({
    backgroundColor: progress > 0 ? MELOGY_BACKGROUND_MEDIUM_LIGHT_GREY : MELOGY_TRANSPARENT,
    "& .MuiLinearProgress-bar": {
        backgroundColor: progress > 98 ? MELOGY_WHITE : MELOGY_BACKGROUND_2XLIGHT_GREY, 
    },
}))

function CreateSongProgressBar({ progress }) {
    return (
        <Box
            sx={{
                width: "100%",
                position: "fixed",
                top: "0",
                left: "0",
                zIndex: 999,
            }}
        >
            <CustomLinearProgress
                variant="determinate"
                value={progress}
                progress={progress}
            />
        </Box>
    )
}

export default CreateSongProgressBar
